const hasOneRow = (rows) => rows && rows?.length === 1;

export default hasOneRow;
